import React, { useEffect, useState } from 'react'
import { Row, Radio, Col, Card, Tag, Button, Table, Input, Divider, Space, Dropdown, Spin, Modal, Form, Select, DatePicker, Tabs } from "antd";
import backArrow from '../../../assets/images/arrow-left-back.svg';
import arrow from '../../../assets/images/arrow.svg';
import calenderIcon from '../../../assets/images/calendar-icon.svg';
import moxeyIcon from '../../../assets/images/Moxey 1.svg';
import bankIcon from '../../../assets/images/fluent-emoji_bank.svg';
import cashIcon from '../../../assets/images/Group.svg';
import doubleCheckIcon from '../../../assets/images/check-double-fill.svg';
import { useNavigate ,useLocation } from 'react-router-dom';
import './tnx-order-details.scss';
import DecimalFormatter from '../../../common/decimal-converter/decimal-converter';
import { checkIsTurkeyKazak } from '../../../util/constantUtility';
import { useTranslation } from 'react-i18next';


const TnxOrderDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
  
    // Destructure the state object to access orderData and orderIndex
    // const {orderData ,orderIndex} = location.state || {};
  
    const [orderDetails, setOrderDetails] = useState({
      
    });

    const activeTab = location.state?.activeTab || "transaction";
    const transactionTab = location.state?.transactionTab || "Order";
    const currency = location.state?.currency
    const orderIndex = location.state?.orderIndex;
    const operatingCountry = location.state?.operatingCountry;
    console.log(orderIndex,"oi")
    const orderData = location.state?.orderData || {};
    useEffect(() => {
        setOrderDetails(orderData);
        console.log(orderData, "data");
      }, [orderData]);
    
    const getIcon = (paymentMode) => {
        const iconMap = {
            Wallet: moxeyIcon,
            Bank: bankIcon,
            Cash: cashIcon,
            null: cashIcon,
            "Bank Transfer":bankIcon,
            "Credit Note":bankIcon,
            "Debit Note":bankIcon,
        };
        return iconMap[paymentMode] || null;
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      }
      
    return (

        <div className='card-container'>
            <div className='tnx-id'>
                <img src={backArrow} alt='backIcon'   style={{ cursor: "pointer" }}
                      onClick={() => navigate("/earnings", { state: { activeTab  , transactionTab  } })} />
                <span style={{ marginLeft: "10px", fontWeight: 700, fontSize: "24px" }}>
                    {orderDetails?.orderNumber || "#ORD000000000"}
                </span>
            </div>

            <div className='amount-container'>
                <div className='amount-value'>
                    <span>
                        {t("EARNING_TXN_TOTAL_ORDER_AMT_LB")}: <span className='amt-color'>
                           &nbsp;{currency}&nbsp;{orderDetails?.paymentSummary?.totalOrderAmount ? <DecimalFormatter amount={orderDetails?.paymentSummary?.totalOrderAmount} country={checkIsTurkeyKazak(operatingCountry) ? "TRY" : currency} flag={false} isShowDecimal={true} />:"0"}
                            {/* {orderDetails?.paymentSummary?.totalOrderAmount || "0"} */}
                            </span>
                    </span>
                    <span>
                        {t("EARNING_TXN_TOTAL_AMT_RECEIVED_LB")}: <span className='amt-color-received'> 
                            &nbsp;{currency}&nbsp;{orderDetails?.paymentSummary?.totalPaymentReceived ? <DecimalFormatter amount={orderDetails?.paymentSummary?.totalPaymentReceived} country={checkIsTurkeyKazak(operatingCountry) ? "TRY" : currency} flag={false} isShowDecimal={true} />:"0"}
                            {/* {orderDetails?.paymentSummary?.totalPaymentReceived || "0"} */}
                            </span>
                    </span>
                    <span>{t("EARNING_TXN_TOTAL_ORDR_AMT_PENDING_LB")}:<span className='amt-pen'>
                        &nbsp;{currency}&nbsp;{orderDetails?.paymentSummary?.totalPaymentPending ? <DecimalFormatter amount={orderDetails?.paymentSummary?.totalPaymentPending} country={checkIsTurkeyKazak(operatingCountry) ? "TRY" : currency} flag={false} isShowDecimal={true} />:"0"}
                        {/* {orderDetails?.paymentSummary?.totalPaymentPending || "0"} */}
                        </span></span>
                </div>
                <div className='amount-status'>
                    <Tag bordered={false} className='tag-color'>
                        {orderDetails?.paymentSummary?.paymentStatus || "Status Pending"}
                    </Tag>
                </div>
            </div>

            <hr style={{ border: "1px dashed #858C9480", opacity: "50%" }} />

            <div className='date-container'>
                <div className='moveDate'>
                    <span>
                        <img src={calenderIcon} alt='date' />
                    </span>
                    <span>{t("EARNING_TXN_MOVE_DATE_LBL")}: {formatDate(orderDetails?.moveDate) || "N/A"}</span>
                </div>
                <span className='move-type'>{orderDetails?.moveType || "N/A"}</span>
            </div>

            <div className='movement-container'>
                <div className='moveDetails'>
                    <span>{t("EARNING_TXN_FROM_LBL")}</span>
                    <strong>{orderDetails?.fromCity || "City"}</strong>
                    <span>{orderDetails?.fromCountry || "Country"}</span>
                </div>
                <div className='arrow'>
                    <img src={arrow} alt='' />
                </div>
                <div  className='moveDetails position'>
                    <span>{t("EARNING_TXN_TO_LBL")}</span>
                    <strong>{orderDetails?.toCity || "City"}</strong>
                    <span>{orderDetails?.toCountry || "Country"}</span>
                </div>
            </div>

    {orderDetails?.payments?.length > 0 &&
            <div className='transaction-details-card'>
                {orderDetails?.payments?.map((txn, index) => (
                    <div key={index} className='tnx-mode'>
                        <div className='tnx-img'>
                            <span>
                                <img src={getIcon(txn?.payment_mode)} alt='icon' />
                            </span>
                            <div className='payment-id'>
                                <span>{txn?.voucherId || "Transaction ID"}</span>
                                <span className='text-pay'>Payment received in {txn?.payment_mode}</span>
                            </div>
                        </div>
                        <div className='payment-details'>
                            <span>
                                &nbsp;{txn?.currency}&nbsp;{txn?.amount ? <DecimalFormatter amount={txn?.amount} country={checkIsTurkeyKazak(operatingCountry) ? "TRY" : txn?.currency} flag={false} isShowDecimal={true} />:"0"}
                                   {" "}
                                {<img src={doubleCheckIcon} alt='checkedIcon' />}
                            </span>
                            <span className='text-pay'>{formatDate(txn?.paidAt) || "N/A"}</span>
                        </div>
                    </div>
                ))}
            </div>}
        </div>

    );
};

export default TnxOrderDetails;